import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const NotFound = () => {
    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            <Navbar />
            
            <div className="flex-grow flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 py-20 text-center">
                <div className="animate-fade-in-up">
                    <h1 className="text-9xl font-extrabold text-[#0D5364] drop-shadow-lg">
                        404
                    </h1>
                    <div className="w-24 h-2 bg-[#1E88A8] mx-auto my-6 rounded-full"></div>
                </div>
                
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 animate-fade-in-up delay-200">
                    Page Not Found
                </h2>
                
                <p className="text-lg sm:text-xl text-gray-600 max-w-lg mx-auto mb-10 animate-fade-in-up delay-400">
                    Oops! The page you're looking for doesn't seem to exist. It might have been moved or deleted.
                </p>
                
                <Link 
                    to="/" 
                    className="inline-flex items-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-sm text-white bg-[#0D5364] hover:bg-[#093d4a] transition-all duration-300 hover:scale-105 hover:shadow-lg animate-fade-in-up delay-600"
                >
                    Back to Home
                </Link>
            </div>

            <Footer />
        </div>
    );
};

export default NotFound;
